module.exports = __webpack_public_path__ + "img/banner1.f75efed6.png";